import './login.css';
import React, { useEffect } from 'react';
import Logo from '@Assets/large.svg';
import Icon from '@Assets/testpilot_svglogo.svg';
import { useAuth } from '@Context/CognitoAuthProvider';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { login, user } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const intendedPath = localStorage.getItem('intendedPath');

      if (intendedPath) {
        localStorage.removeItem('intendedPath');
        navigate(intendedPath, { replace: true });
      } else {
        if (user.profile) {
          navigate('/home', { replace: true });
        } else {
          navigate('/gpt', { replace: true });
        }
      }
    }
  }, [user]);

  return (
    <>
      <div className="main flex h-screen flex-col items-center justify-center gap-2">
        <div className="login-box w-full max-w-md rounded-md bg-white p-8">
          <div className="flex justify-center">
            <img src={Logo} alt="Trajector Logo" />
          </div>
          <div
            data-testid="login-header"
            className="login-title pt-12 text-center text-2xl font-bold text-gray-950"
          >
            Log in to Test Pilot
          </div>
          <div className="mb-6 mt-8 flex flex-row items-center justify-between rounded border border-gray-300 p-4 text-sm">
            <div className="flex flex-row items-center justify-center gap-2">
              <img className="h-9 w-9" src={Icon} alt="Trajector Icon" />
              Log in with Trajector SSO
            </div>
            <button
              data-testid="login-button"
              className="login-btn line-text rounded bg-blue-800 px-4 py-1.5 font-medium text-white hover:bg-blue-900"
              onClick={login}
            >
              Log in
            </button>
          </div>

          <div className="text-center text-xs text-gray-950">
            Having trouble logging in?&nbsp;
            <a
              href="#"
              className="line-contact text-blue-400 hover:text-blue-800"
            >
              &nbsp;Contact us
            </a>
            .
          </div>
          <div className="line mt-6 text-center text-xs text-gray-500">
            <p>
              Copyright © 2024 AI Test Case Generator. All rights reserved.
            </p>
            <div className="flex justify-center space-x-2">
              <a
                href="#"
                className="privacy-policy text-blue-400 hover:text-blue-800"
              >
                Privacy policy
              </a>
              <span>|</span>
              <a href="#" className="terms text-blue-400 hover:text-blue-800">
                Terms and conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
